import server from '../../public/server/server'
const visitsApi = {
    //----------------------十户联防-----------------------------------
    queryListByPage:server.requestPath +  '/defence/List', // 获取列表
    queryMember:server.requestPath +  '/defence/queryMember', // 查询成员
    del:server.requestPath +  '/defence/del', // 删除
    detail:server.requestPath +  '/defence/ten/detail', // 详情
	
	// ---------------------家乡圈----------------------------------
    circleList:server.requestPath +  '/circle/List', // 家乡圈内容列表
    commentList:server.requestPath +  '/circle/comment/List', // 家乡圈评论列表
    circleDetail:server.requestPath +  '/circle/detail', // circle-----根据id获取家乡圈信息
	circleSave:server.requestPath+'/circle/saveCircle',//circle-----家乡圈发表评论
	memberSave:server.requestPath+'/app/ten/member/save',//circle-----十户联防成员 添加
	memberDel:server.requestPath+'/app/ten/member/del',//circle-----十户联防成员 删除
	
}


export {
	visitsApi
}
